import { useTranslate } from '@va/localization';
import { SelectDropdown, SelectDropdownOption, TextInput } from '@va/ui/design-system';
import { getBusinessSectorOptions, getBusinessSizeOptions, getBusinessTypeOptions } from '@va/util/helpers';
import { useFormik } from 'formik';

export type OnboardingBusinessDetails = {
  businessType?: SelectDropdownOption<number>;
  businessSize?: SelectDropdownOption<number>;
  businessSector?: SelectDropdownOption<number>;
  companyName?: string;
};

const formFieldNames = {
  companyName: 'companyName',
  businessType: 'businessType',
  businessSize: 'businessSize',
  businessSector: 'businessSector',
};

export const BusinessDetailsForm: React.FC<{
  formId?: string;
  onSubmit: (values: OnboardingBusinessDetails) => void;
  initialValues?: OnboardingBusinessDetails;
}> = ({ formId, onSubmit, initialValues = {} }) => {
  const translate = useTranslate();

  const { handleChange, values, errors, handleSubmit, setFieldValue } = useFormik<OnboardingBusinessDetails>({
    onSubmit,
    initialValues,
  });

  return (
    <form id={formId} className='max-w-600px mx-auto grid grid-cols-2 gap-3 sm:grid-cols-1' onSubmit={handleSubmit}>
      <SelectDropdown
        size='medium'
        error={errors.businessType}
        buttonClassName='rounded-12!'
        selectedOption={values.businessType}
        dropdownOptions={getBusinessTypeOptions(translate)}
        placeholderText={translate('onboarding.businessDetails.businessType.placeholder')}
        onChange={(option) => {
          setFieldValue(formFieldNames.businessType, option);
        }}
      />
      <SelectDropdown
        size='medium'
        error={errors.businessSize}
        buttonClassName='rounded-12!'
        selectedOption={values.businessSize}
        dropdownOptions={getBusinessSizeOptions(translate)}
        placeholderText={translate('onboarding.businessDetails.businessSize.placeholder')}
        onChange={(option) => {
          setFieldValue(formFieldNames.businessSize, option);
        }}
      />
      <SelectDropdown
        size='medium'
        buttonClassName='rounded-12!'
        error={errors.businessSector}
        selectedOption={values.businessSector}
        dropdownOptions={getBusinessSectorOptions(translate)}
        placeholderText={translate('onboarding.businessDetails.businessSector.placeholder')}
        onChange={(option) => {
          setFieldValue(formFieldNames.businessSector, option);
        }}
      />
      <TextInput
        heightClass='h-12'
        onChange={handleChange}
        error={errors.companyName}
        value={values.companyName}
        inputWrapperClassName='rounded-12!'
        name={formFieldNames.companyName}
        placeholder={translate('onboarding.businessDetails.companyName.placeholder')}
        clearField={() => {
          setFieldValue(formFieldNames.companyName, '');
        }}
      />
    </form>
  );
};
